/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace nsSearchBarAdapter
 */
class nsSearchBarAdapter {

    constructor() {};

    adaptProductSearchResults(dataset) {
        var searchResults = [
            {
                "sectionTitle": "Products",
                "resultsList": dataset
            }
        ];
        return searchResults;
    };

    adaptLookAheadResults(dataset, market, lang) {
        if (dataset) {
            let productArr = [];
            let products = dataset.products;
            for(var i = 0; i < products.length; i++) {
                var item = {};
                item.img = dataset.products[i].getMarketChild(market).getImageUrl();
                item.itemName = dataset.products[i].getLanguageChild(lang).getTitle();
                item.sku = dataset.products[i].getSku();
                productArr.push(item);
            }
            return productArr;
        }
    }

    adaptPopularProductsResults(dataset, market, lang) {
        let productArr = [];
        if (dataset) {
            dataset.forEach((productObj) => {
                let item = {};
                item.img = productObj.getMarketChild(market).getImageUrl();
                item.itemName = productObj.getLanguageChild(lang).getTitle();
                item.sku = productObj.getSku();
                productArr.push(item)
            })
        }
        return productArr;
    }
}

export default new nsSearchBarAdapter();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/nsSearchBarAdapter.js
// module id = 313
// module chunks = 0